import SlideoutMenu from '@orn/shared-web/components/SlideoutMenu';
import Tooltip, { TooltipTrigger } from '@orn/shared-web/components/Tooltip';
import { InfoCircleIcon, SwitchHorizontalIcon } from '@orn/shared-web/icons';
import { cx } from '@orn/shared-web/utils/cx';

import { formatCalendarDate, toCurrency } from '../../../utils/formatting';
import Entity from '../../entity';

import type { EntityAvatarFragment } from '../../entity/EntityAvatar/__generated__/EntityAvatar.gql';
import type { CalendarDate } from '@internationalized/date';

interface ITransactionPairRowProps {
  pairedTransaction: {
    id: string;
    amount: string;
    date: CalendarDate;
    financialAccount: EntityAvatarFragment;
  } | null;
  onClick?: (transactionId: string) => void;
}

const TransactionPairRow = ({ pairedTransaction, onClick }: ITransactionPairRowProps) => {
  if (!pairedTransaction) {
    return null;
  }

  const amountNumber = Number(pairedTransaction.amount);
  const isCredit = amountNumber < 0;
  const formattedAmount = isCredit
    ? `+${toCurrency(Math.abs(amountNumber))}`
    : `-${toCurrency(Math.abs(amountNumber))}`;

  return (
    <SlideoutMenu.Row
      icon={<SwitchHorizontalIcon className="size-4.5 shrink-0" />}
      title={
        <div className="flex items-center gap-1">
          <span className="whitespace-nowrap">Paired with</span>
          <Tooltip title="This is a transfer between your accounts. Because the added and subtracted amounts are equal, it nets out to zero total spending.">
            <TooltipTrigger>
              <InfoCircleIcon className="size-3.5 shrink-0" />
            </TooltipTrigger>
          </Tooltip>
        </div>
      }
      onClick={onClick ? () => onClick(pairedTransaction.id) : undefined}
    >
      <div className="text-primary text-md flex min-w-0 items-center gap-2 font-medium">
        <Entity.Avatar entity={pairedTransaction.financialAccount} size="xs" />
        {formatCalendarDate(pairedTransaction.date, 'medium')}
        <span>•</span>
        <span className={cx(isCredit ? 'text-success-primary' : 'text-error-primary')}>{formattedAmount}</span>
      </div>
    </SlideoutMenu.Row>
  );
};

export default TransactionPairRow;
